import SpotlightSection, { VisualFrame } from "@/components/wynn/SpotlightSection";

const MODULES = [
  ["01", "The 5-Minute Reset", "4 min"],
  ["02", "The Becoming", "6 min"],
  ["03", "Sound Bath I", "8 min"],
  ["04", "Unblocking", "5 min"],
];

function CoursesVisual() {
  return (
    <VisualFrame
      gradient="linear-gradient(135deg, rgba(255,183,198,0.24) 0%, rgba(168,230,255,0.2) 60%, rgba(230,191,255,0.18) 100%)"
    >
      <div className="w-full px-7 md:px-10">
        {MODULES.map(([n, title, dur]) => (
          <div
            key={n}
            className="flex items-center justify-between py-3 border-b border-[#F4F1EC]/12 last:border-b-0"
          >
            <div className="flex items-center gap-4">
              <span className="font-display text-[18px] text-[#F4F1EC]/40">{n}</span>
              <span className="font-display text-[20px] text-[#F4F1EC]">{title}</span>
            </div>
            <span className="font-body text-[11px] uppercase tracking-[0.18em] text-[#F4F1EC]/50">
              {dur}
            </span>
          </div>
        ))}
      </div>
    </VisualFrame>
  );
}

export default function CoursesSpotlight() {
  return (
    <SpotlightSection
      id="courses"
      testId="wynn-courses"
      reverse
      labelColor="#FFB7C6"
      label="Courses · in the full app"
      lead="Tiny courses you can"
      accent="actually finish"
      body="Bite-size programs to walk you back to your work — The 5-Minute Reset, The Becoming, sound-bath libraries and more. A few honest minutes at a time, never a syllabus to dread. Small enough to begin today, real enough to change the week."
      tags={["Bite-size", "7 programs", "Go at your pace"]}
      accentGradient="radial-gradient(50% 55% at 82% 25%, rgba(255,183,198,0.18) 0%, rgba(7,6,8,0) 60%), radial-gradient(50% 55% at 15% 80%, rgba(168,230,255,0.16) 0%, rgba(7,6,8,0) 65%)"
      visual={<CoursesVisual />}
    />
  );
}
